import React, { useState } from "react";

import { Button } from "equator-design-system";
import { ChevronDown } from "lucide-react";
import { twMerge } from "tailwind-merge";

interface CollapsibleProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  expanded?: boolean;
}

const CollapseView = ({
  title,
  children,
  className,
  titleClassName,
  expanded = false
}: Readonly<CollapsibleProps>) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex flex-col">
      <div
        className={twMerge(
          "flex justify-between items-center cursor-pointer px-4 h-[40px]",
          className
        )}
      >
        <span
          className={twMerge(
            "text-base text-txtHeading font-semibold",
            titleClassName
          )}
        >
          {title}
        </span>
        <Button
          className={twMerge(isExpanded ? "rotate-180" : "")}
          onClick={toggleExpand}
          type="button"
          aria-label={`Toggle ${title} section`}
        >
          <ChevronDown className="w-[24px]" />
        </Button>
      </div>
      {isExpanded && <div className="mt-2">{children}</div>}
    </div>
  );
};

export default CollapseView;
